import {
    Box,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    DrawerCloseButton,
    Flex,
    Heading,
    IconButton,
    Image,
    Text,
    useColorMode,
    useDisclosure,
    useMediaQuery,
} from "@chakra-ui/react";
import { BiMenu } from "react-icons/bi";
import {SiHomeassistant} from 'react-icons/si'
import {GiGrapes} from 'react-icons/gi'
import {FcShop} from 'react-icons/fc'
import {RiShoppingBasket2Fill} from 'react-icons/ri'
import {FaUser} from 'react-icons/fa'
import {HiOutlineLogout} from 'react-icons/hi'

import { apriModaleLogin, apriModaleLogout } from "./Atoms";
import { utenteAtom } from "./Atoms";
import { useAtom } from "jotai";

import {
  NavLink,
} from "react-router-dom";
  
  const AppMenu = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { colorMode } = useColorMode();
    const [apriModLogin, setApriModLogin] = useAtom(apriModaleLogin);
    const [apriModLogout, setApriModLogout] = useAtom(apriModaleLogout);
    const [utente, setUtente] = useAtom(utenteAtom);
  
    const [isBiggerThanMobile] = useMediaQuery("(min-width: 480px)");

    const clickElementoMenu = (elemento) => {

        switch (elemento.click) {
          case "login":
            setApriModLogin(true);
            onClose();
            break;

          case "logout":
            setApriModLogout(true);
            onClose();
            break;
        
          default:
            onClose();
            break;
        }
    }

    const visibilitaElementoMenu = (elemento) => {

      switch (elemento.visible) {
        case "nonLoggato":
          if(Object.entries(utente).length){
            return false
          }
          else{
            return true
          }
          break;

        case "loggato":
          if(Object.entries(utente).length){
            return true
          }
          else{
            return false
          }
          break;

          case "admin":
          if(Object.entries(utente).length){
            if(utente.ruolo === "3"){
              return true
            }
          }
          else{
            return false
          }
          break;
      
        default:
          return true
          break;
      }
  }

    const apps  = [
      {
        name: "Home",
        description: "Torna alla Home",
        icon: <SiHomeassistant fontSize="30px"/>,
        url: "/",
        click: '',
        visible: '',
      },
      // {
      //   name: "Lista Cantine",
      //   description: "Le Cantine e i loro eventi",
      //   icon: <GiGrapes fontSize="30px"/>,
      //   url: "/lista-cantine",
      //   click: '',
      //   visible: '',
      // },
      // {
      //   name: "Login",
      //   description: "Accedi al tuo profilo",
      //   icon: <FaUser fontSize="30px"/>,
      //   url: "#",
      //   click: 'login',
      //   visible: 'nonLoggato',
      // },
      // {
      //   name: "Il tuo profilo",
      //   description: "Le tue informazioni",
      //   icon: <FaUser fontSize="30px"/>,
      //   url: "profilo",
      //   click: '',
      //   visible: 'loggato',
      // },
      // {
      //   name: "Gestisci Prodotti",
      //   description: "Gestisci i prodotti dello Shop",
      //   icon: <FcShop fontSize="30px"/>,
      //   url: "gestione-prodotti",
      //   click: '',
      //   visible: 'admin',
      // },
      // {
      //   name: "I tuoi ordini",
      //   description: "Controlla i tuoi ordini",
      //   icon: <FaUser fontSize="30px"/>,
      //   url: "ordini",
      //   click: '',
      //   visible: 'loggato',
      // },
      // {
      //   name: "Shop",
      //   description: "Siamo ciò che mangiamo",
      //   icon: <FcShop fontSize="30px"/>,
      //   url: "shop",
      //   click: '',
      //   visible: '',
      // },
      // {
      //   name: "Carrello",
      //   description: "Controlla i tuoi prodotti",
      //   icon: <RiShoppingBasket2Fill fontSize="30px"/>,
      //   url: "carrello",
      //   click: '',
      //   visible: '',
      // },
      {
        name: "Logout",
        description: "Esci dal tuo account",
        icon: <HiOutlineLogout color="red" fontSize="30px"/>,
        url: "#",
        click: 'logout',
        visible: 'loggato',
      },

    ];
  
    return (
      <>
        <IconButton
          marginLeft={2}
          aria-label="app-menu"
          icon={<BiMenu />}
          onClick={onOpen}
        />
  
        <Drawer
          placement={isBiggerThanMobile ? "right" : "top"}
          isOpen={isOpen}
          onClose={onClose}
        >
          <DrawerOverlay />
  
          <DrawerContent>
          <DrawerCloseButton />
            <DrawerHeader>
              <Heading size="xs">Menu</Heading>
            </DrawerHeader>
  
            <DrawerBody>
              {apps.map(({ name, icon, url, description, visible }, index) => (
                <NavLink key={index} to={url} onClick={() => clickElementoMenu(apps[index])} hidden={!visibilitaElementoMenu(apps[index])}>
                  <Flex
                    marginY={4}
                    alignItems="center"
                    padding={2}
                    borderRadius={12}
                    _hover={{
                      backgroundColor:
                        colorMode === "light" ? "gray.200" : "gray.600",
                    }}
                  >
                    {icon}
                    <Box marginLeft={4}>
                      <Heading size="sm">{name}</Heading>
                      {description && <Text fontSize="xs">{description}</Text>}
                    </Box>
                  </Flex>
                </NavLink>
              ))}
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </>
    );
  };
  
  export default AppMenu;